<template>
  <div class="bundle-summary flex flex-col w-full grow max-h-full border border-neutral-300 overflow-hidden">
    <BundleSummaryHeader />
    <div class="flex flex-col grow min-h-0 overflow-y-auto">
      <div
        v-if="!ready"
        class="w-full flex-center min-h-[200px]"
      >
        <Loader class="text-gray-300" />
      </div>
      <div
        v-else-if="totalQuantity || $cart.nonBundleItems.length"
        class="flex flex-col pb-2"
      >
        <template v-if="totalQuantity">
          <MonthlyFIDCard v-if="isSub" />
          <SpoonCard v-if="store.isCoffeeBundle" />
          <ShakerBottleCard v-else />
        </template>
        <CartContents v-if="$cart.nonBundleItems.length" />
        <template v-if="totalQuantity">
          <BundleProductCard
            v-for="selection in selectedProducts"
            :key="selection.key"
            :selection="selection"
            :editable="true"
          />
        </template>
      </div>
      <p
        v-else-if="totalQuantity === 0"
        class="w-full flex-center min-h-[200px]"
      >
        {{ $t('bundler.empty_cart_label') }}
      </p>
    </div>
    <BundleSummaryFooter />
  </div>
  <vue-modal
    v-model="onetimeConfirm"
    @close="onetimeConfirm = false"
  >
    <BundleRecovery @close="onetimeConfirm = false" />
  </vue-modal>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBundleStore } from '@/stores'
import Loader from '../shared/loader.vue'
import BundleSummaryHeader from './bundle-summary-header.vue'
import BundleSummaryFooter from './bundle-summary-footer.vue'
import MonthlyFIDCard from './monthly-fid-card.vue'
import ShakerBottleCard from './shaker-bottle-card.vue'
import SpoonCard from './spoon-card.vue'
import BundleProductCard from './bundle-product-card.vue'
import CartContents from './cart-contents.vue'
import BundleRecovery from './bundle-recovery.vue'
export interface Props {
  hideAddMore?: boolean
}
defineProps<Props>()
const store = useBundleStore()
const { ready, isSub, totalQuantity, selectedProducts, onetimeConfirm } = storeToRefs(store)
</script>

<style>
@reference 'tailwindcss';

.bundle-summary {
  transition-property: border-color, box-shadow;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  &.highlight {
    border-color: var(--color-green);
    box-shadow: 5px 5px 8px rgba(94, 156, 43, 0.5);
  }
}
.free-badge {
  @apply absolute h-full text-center top-0 right-0 px-1 bg-green-500 font-bold text-white;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  @media (prefers-contrast: more) {
    @apply text-black;
  }
}

.cart .bundle-summary,
.sidebar .bundle-summary {
  @apply rounded-2xl;
}

.cart-page .bundle-summary header button {
  display: none;
}
.cart-page .bundle-summary {
  max-height: calc(100vh - 150px);
}

.sidebar .continue-shopping {
  @apply hidden;
}

@media screen and (min-width: 640px) {
  .sidebar {
    .sticky {
      top: 102px;
    }
    .bundle-summary {
      max-height: calc(100vh - 118px);
    }
  }
}
</style>
